(() => {
  const banner = document.getElementById('BirdConsentBanner');
  const settingsButton = document.getElementById('BirdConsentSettings');

  if (!banner || !settingsButton) return;

  const choices = banner.querySelector('#BirdConsentChoices');
  const panel = banner.closest('details');
  const manageButton = banner.querySelector('[data-consent-action="manage"]');
  const saveButton = banner.querySelector('[data-consent-action="save"]');
  const purposeInputs = [...banner.querySelectorAll('[data-consent-purpose]')];
  const status = banner.querySelector('[data-consent-status]');
  const actionButtons = [...banner.querySelectorAll('[data-consent-action]')];
  let loadStarted = false;
  let apiReady = false;
  let pendingConsent = null;
  let returnFocus = settingsButton;

  const privacyApi = () => window.Shopify?.customerPrivacy;
  const hasSavedChoice = () => {
    const current = privacyApi()?.currentVisitorConsent?.();
    return ['preferences', 'analytics', 'marketing'].every((purpose) =>
      current?.[purpose] === 'yes' || current?.[purpose] === 'no'
    );
  };
  const syncSettingsVisibility = () => {
    settingsButton.hidden = hasSavedChoice();
  };
  settingsButton.hidden = true;

  const setStatus = (message = '') => {
    if (!status) return;
    status.textContent = message;
    status.hidden = message === '';
  };

  const setBusy = (busy) => {
    banner.setAttribute('aria-busy', String(busy));
    actionButtons.forEach((button) => {
      button.disabled = busy;
    });
  };

  const syncChoices = () => {
    if (typeof privacyApi()?.currentVisitorConsent !== 'function') return;
    const current = privacyApi().currentVisitorConsent();
    purposeInputs.forEach((input) => {
      input.checked = current[input.dataset.consentPurpose] === 'yes';
    });
  };

  const openBanner = (force = false) => {
    const shouldShow = typeof privacyApi()?.shouldShowBanner === 'function' && privacyApi().shouldShowBanner();
    if (force || (shouldShow && !hasSavedChoice())) {
      if (!panel.open) returnFocus = document.activeElement;
      panel.open = true;
      syncChoices();
      banner.querySelector('[data-consent-action="accept"]').focus();
    }
  };

  const closeBanner = () => {
    setBusy(false);
    setStatus();
    panel.open = false;
    choices.hidden = true;
    saveButton.hidden = true;
    manageButton.hidden = false;
    manageButton.setAttribute('aria-expanded', 'false');
    const focusTarget = returnFocus?.isConnected && returnFocus !== document.body && !returnFocus.hidden
      ? returnFocus
      : settingsButton.hidden ? document.querySelector('[data-bird-consent-settings]') : settingsButton;
    focusTarget?.focus({ preventScroll: true });
  };

  const submitConsent = (consent) => {
    if (!apiReady || typeof privacyApi()?.setTrackingConsent !== 'function') {
      pendingConsent = consent;
      setBusy(true);
      setStatus('Loading secure cookie controls…');
      loadPrivacyApi();
      return;
    }

    setBusy(true);
    setStatus('Saving your choices…');
    privacyApi().setTrackingConsent(consent, (result) => {
      if (result?.error) {
        setBusy(false);
        setStatus('We could not save your cookie choices. Please try again.');
        return;
      }
      syncSettingsVisibility();
      closeBanner();
    });
  };

  const loadPrivacyApi = () => {
    if (apiReady) return;
    if (typeof privacyApi()?.setTrackingConsent === 'function') {
      apiReady = true;
      syncChoices();
      syncSettingsVisibility();
      if (pendingConsent) {
        const consent = pendingConsent;
        pendingConsent = null;
        submitConsent(consent);
      } else {
        openBanner(false);
      }
      return;
    }
    if (loadStarted) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      settingsButton.hidden = false;
      setBusy(false);
      setStatus('Cookie controls are unavailable. Please reload and try again.');
      return;
    }

    loadStarted = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      loadStarted = false;
      if (error || typeof privacyApi()?.setTrackingConsent !== 'function') {
        settingsButton.hidden = false;
        setBusy(false);
        setStatus('Cookie controls are unavailable. Please reload and try again.');
        return;
      }
      apiReady = true;
      syncChoices();
      syncSettingsVisibility();
      if (pendingConsent) {
        const consent = pendingConsent;
        pendingConsent = null;
        submitConsent(consent);
      } else {
        openBanner(false);
      }
    });
  };

  banner.addEventListener('click', (event) => {
    if (event.target.closest('.bird-consent__close')) {
      closeBanner();
      return;
    }
    const action = event.target.closest('[data-consent-action]')?.dataset.consentAction;
    if (!action) return;

    if (action === 'accept') {
      submitConsent({ preferences: true, analytics: true, marketing: true });
    } else if (action === 'reject') {
      submitConsent({ preferences: false, analytics: false, marketing: false });
    } else if (action === 'manage') {
      choices.hidden = false;
      saveButton.hidden = false;
      manageButton.hidden = true;
      manageButton.setAttribute('aria-expanded', 'true');
      purposeInputs[0]?.focus();
    } else if (action === 'save') {
      submitConsent(Object.fromEntries(purposeInputs.map((input) => [input.dataset.consentPurpose, input.checked])));
    }
  });

  panel.addEventListener('toggle', () => {
    if (panel.open && apiReady) syncChoices();
  });
  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel.open) {
      event.preventDefault();
      closeBanner();
    }
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bird-consent-settings]');
    if (!trigger) return;
    event.preventDefault();
    openBanner(true);
    returnFocus = trigger;
    loadPrivacyApi();
  });
  document.addEventListener('visitorConsentCollected', () => {
    syncChoices();
    syncSettingsVisibility();
  });
  loadPrivacyApi();
})();
